import React from 'react';
import { connect } from 'react-redux';
import dataModel from '../../../models/DataModel';
import TextMap from '../../../helpers/TextMap';
import ReportHeader from '../../../containers/ManagerDashboard/ReportHeader';
import LoadingDots from '../../../components/LoadingDots';
import ChangeTeamLeadPopup from '../../../components/ChangeTeamLeadPopup/index.js';
import TableHeader from '../../../components/Table/TableHeader';
import TableRow from '../../../components/Table/TableRow';
import CollectionDataSource from '../../../dao/DataSource/CollectionDataSource';
import AnalyticsLogger from '../../../helpers/analytics/analyticsLogger';
import PopupMenu from '../../../components/PopupMenu';
import UserPopup from '../UserPopup';
import listViewIcon from '../../../assets/images/listview-icon.svg';
import WizardView from '../../../components/WizardView';
import AddAffiliateCompanyWizard from '../../../containers/CompaniesContainer/AddAffiliateCompanyWizard';
import VendorUserSelection from '../VendorUserSelection';
import PhotoCropperPopup from '../../../components/PhotoCropperPopup';
import DirectorySearchFilter from '../DirectorySearchFilter';
import DeactivateUserPopup from '../../../components/DeactivateUserPopup';

import addIcon from '../../../assets/images/plus-circle.svg';

import userService from '../../../services/userService.js';

import helper from '../../../helpers/misc-functions.js';

import './Users.scss';
import { setFilteredUsers, setUsersList } from '../../../models';
import { isNil } from 'lodash';
import CheckBox from '../../../components/CheckBox/index.js';

let PAGE_SIZE = 0;

export const userDescriptor = { user: { companies: {}, role: {}, directories: {}, markets: {}, market_vendor_users: { market: {} }, vendor_markets: {} } };

export class Users extends React.Component {

  constructor(props) {
    super(props);
    this.isInitializing = false;
    this.textMap = new TextMap();
    this.accent = (this.props.currentCompany && this.props.currentCompany.accent_color) ? this.props.currentCompany.accent_color : '#CD03A';

    this.state = {
      users: null,
      teams: null,
      oldUsers: null,
      sortField: 'last_name',
      ascending: true,
      loadingUsers: true,
      menu: null,
      user: null,
      displayPopup: null,
      readyForUpdate: null,
      filter: null,
      usersFiltered: null,
      copyUsers: null,
      searchString: '',
      usersListState: null,
      isDisabledUsersIncluded: false,
      companyIds: null,
    };

    this.handleLoadMoreUsers = this.handleLoadMoreUsers.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.handleOptions = this.handleOptions.bind(this);
    this.handleImageRemove = this.handleImageRemove.bind(this);
    this.handlePopup = this.handlePopup.bind(this);
    this.handleUpdateCompanies = this.handleUpdateCompanies.bind(this);
    this.handleMenuSelection = this.handleMenuSelection.bind(this);
    this.handleCloseMenu = this.handleCloseMenu.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleWizardDone = this.handleWizardDone.bind(this);
    this.handleSelectVendorUsers = this.handleSelectVendorUsers.bind(this);
    this.handleVendorUserOk = this.handleVendorUserOk.bind(this);
    this.handleCropModal = this.handleCropModal.bind(this);
    this.handleUserUpdate = this.handleUserUpdate.bind(this);
    this.handleUserCreate = this.handleUserCreate.bind(this);
    this.handleUserFieldsValidation = this.handleUserFieldsValidation.bind(this);
    this.handlePasswordsMatch = this.handlePasswordsMatch.bind(this);
    this.handleCropPhoto = this.handleCropPhoto.bind(this);
    this.handleCancelCrop = this.handleCancelCrop.bind(this);
    this.handleEndCrop = this.handleEndCrop.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleClosePopup = this.handleClosePopup.bind(this);
    this.handleDisplayPopup=this.handleDisplayPopup.bind(this);
    this.handleTeamRetrieval = this.handleTeamRetrieval.bind(this);
    this.handleSuspendUser = this.handleSuspendUser.bind(this);
    this.toggleDisabledUsersCheckBox = this.toggleDisabledUsersCheckBox.bind(this);
    const currentRole = dataModel.usersDAO.currentUser ? dataModel.usersDAO.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });
    this.hideLoader = this.hideLoader.bind(this);

  }

  componentDidMount() {

    this.state.usersListState = null;

    PAGE_SIZE = Math.floor(window.innerHeight / 75);
    if (this.props.permissions && this.props.permissions.isSuperUser && this.props.currentUser) {
      this.companiesDataSource = new CollectionDataSource('CompaniesCollection', 'Company', { companies: { vendor_companies: { additionalFields: ['is_vendor_company'] } } }, this.handleUpdateCompanies, 0, null, this.props.currentUser.id, null, 'directoryCompanies');
    }
    this.initializeData(this.props.currentCompany, this.props.permission, this.props.currentUser, 0);

    if(this.props && this.props.currentCompany){
      this.teamsDataSource = new CollectionDataSource('TeamsCollection', 'Team', { team: { lead_user: {}, markets: {} } },
        this.handleTeamRetrieval, 'TeamsCollection', this.props.currentCompany.id);
      this.teamsDataSource.current();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if ((prevProps.currentCompany != this.props.currentCompany && this.props.currentCompany) ||
      (prevProps.currentUser != this.props.currentUser && this.props.currentUser)) {
      this.initializeData(this.props.currentCompany, this.props.permission, this.props.currentUser);
    }
    if(prevState.usersListState && prevState.usersListState.length != this.props.usersList.length) {
      this.state.usersListState = this.props.usersList;
    }
  }

  componentWillUnmount() {
    if (this.companiesDataSource) {
      this.companiesDataSource.release();
      this.companiesDataSource = null;
    }
    if (this.vendorUsersDataSource) {
      this.vendorUsersDataSource.release();
      this.vendorUsersDataSource = null;
    }
    if (this.usersDataSource) {
      this.usersDataSource.release();
      this.usersDataSource = null;
    }
    if (this.usersDataSource2) {
      this.usersDataSource2.release();
      this.usersDataSource2 = null;
    }
    if (this.directoriesDataSource) {
      this.directoriesDataSource.release();
      this.directoriesDataSource = null;
    }
    if (this.currentCompanyDataSource) {
      this.currentCompanyDataSource.release();
      this.currentCompanyDataSource = null;
    }
    if (this.adminCompanyDataSource) {
      this.adminCompanyDataSource.release();
      this.adminCompanyDataSource = null;
    }
    if (this.teamsDataSource) {
      this.teamsDataSource.release();
      this.teamsDataSource = null;
    }
  }

  hideLoader() {
    this.setState({ loadingUsers: false });
  }

  handleTeamRetrieval(teams, action, acData, fetchedData) {    
    this.setState({ teams: teams.teams });
  }

  getUsersList(pageNo, companyId){
    let _this = this;
    let companyIds = null;
    let seeSuspended = _this.props.currentUser && (_this.props.currentUser.super_admin || _this.props.currentUser.role.name == 'admin') && _this.state.isDisabledUsersIncluded;
    const usersList = _this.state.filter ? _this.props.filteredUsers : _this.state.usersListState;
    if(companyId){
      companyIds = companyId;
    }
    else if(this.state.companyIds){
      companyIds = this.state.companyIds;
    }
    _this.setState({ loadingUsers: true });
    userService.search(_this.state.searchString, companyIds,
       '', companyIds ? false : true, seeSuspended, _this.state.sortField, _this.state.ascending,
      (!isNil(pageNo) ? pageNo : _this.props.pageNumber) + 1, PAGE_SIZE, { recordDescriptor: userDescriptor }, _this.hideLoader).then(response => {
        _this.state.searchString == response.searchText && _this.props.setUsersList(response);
        _this.setState({ usersListState: _this.props.usersList });
        _this.createTableRows();
        _this.setState({ loadingUsers: false });
        // this.scrollInProgress = false
      });
  }

  initializeData(currentCompany, permissions, currentUser, pageNo = 0) {   
    this.isInitializing = true;
    
    if (currentCompany && currentUser) {
      if (this.companiesDataSource) {
        this.companiesDataSource.current();
      }
      this.getUsersList(pageNo);
    }
    
    // Reset flag after a short delay
    setTimeout(() => {
      this.isInitializing = false;
    }, 100);
  }

  handleUpdateCompanies(companies, action, acData, fetchedData) {
    if (acData && acData.type == 'deleteVendorCompany') {
      if (this.vendorUsersDataSource) {
        this.vendorUsersDataSource.current();
      }
    }
    this.setState({ companies: companies.companies });
  }

  handleSort(sortField, direction) {
    const ascending = direction == 'up';
    if (sortField != this.state.sortField || ascending != this.state.ascending) {
      this.setState({ loadingUsers: true, sortField, ascending }, () => {
        this.getUsersList(0);
      });
    }
  }

  createTableHeader() {
    let caretTypes = [
      { type: 'first_name', headerName: 'First Name', first: true },
      { type: 'last_name', headerName: 'Last Name' },
      { type: 'phone', headerName: 'Phone' },
      { type: 'email', headerName: 'Email' },
      { type: 'company_name', headerName: 'Company' },
      { type: 'role', headerName: 'Permission' },
      { type: 'markets', headerName: 'Markets' },
    ];
    if (this.props.permissions && (this.props.permissions.canDeleteUser || this.props.permissions.canEditUser)) {
      caretTypes.push({ type: 'options', headerName: '' });
    }
    this.rowTypes = caretTypes.map(x => x.type);

    const sortDirectionClass = this.state.ascending ? '' : 'down';

    return (
      <TableHeader
        accent={this.accent}
        sortDirectionClass={sortDirectionClass}
        handleSort={this.handleSort}
        sortedType={this.state.sortField}
        caretTypes={caretTypes}
        reportType={'users'}
      />
    );
  }

  createTableRows() {
    let even = false;
    const users = this.state.usersListState;
    if (users) {
      if (users.length == 0 && !this.state.loadingUsers) {
        return <div className="no-matches-indicator">No Users Found...</div>;
      } else {
        return users.map((user, i) => {
          even = !even;
          const rowClassName = 'users-table__row'
            + (even ? ' users-table__row--even' : '')
            + (user.status != 0 ? ' users-table__row--in-progress' : '');
          let digest = '';
          for (let key in user) {
            if (key) {
              digest += user[key];
            }
          }
          const userKey = user.id + digest;
          return (

            <div key={userKey} className={rowClassName}>
           
              <TableRow
                hasCheckBox={false}
                selectedItem={user}
                even={even}
                type={'users'}
                accent={this.accent}
                isVendorUser={this.isVendorUser(user)}
                optionsHandler={this.handleOptions}
                types={this.rowTypes}
                currentCompany={this.props.currentCompany}
              />
            </div>
          );
        });
      }

    }

    else {
      return null;
    }

  }
  handleClosePopup() {
    this.initializeData(this.props.currentCompany, this.props.permission, this.props.currentUser, 0);
    this.setState({ displayPopup: false });
  }

  handlePopup(e) {
    const displayPopup = e.currentTarget.getAttribute('data-popup');
    let { editUser } = this.state;
    if (displayPopup == 'add_user') {
      editUser = { settings: {} };
    }
    this.setState({ displayPopup, editUser });
  }

  handleLoadMoreUsers(){
    this.getUsersList();
  }

  handleOptions(event, user) {
    const menu = this.createMoreMenu(event, user);
    this.setState({ menu, user });
  }

  createMoreMenu(event, user) {
    if (!this.props.permissions || (!this.props.permissions.canDeleteUser && !this.props.permissions.canEditUser)) {
      return null;
    }
    const menuOptions = [];
    if (this.props.permissions && (this.props.permissions.canEditUser && (!this.isVendorUser(user) || this.props.permissions.isSuperUser))) {
      menuOptions.push({
        type: 'edit',
        name: 'Edit',
        separated: this.props.permissions && this.props.permissions.canDeleteUser && this.props.permissions.canCreateUser ? false : true,
      });
    }
    if (this.props.permissions && this.props.permissions.canDeleteUser && !this.isVendorUser(user)) {
      menuOptions.push({
        type: user.suspended ? 'unsuspend' : 'suspend',
        name: user.suspended ? 'Reactivate' : 'Deactivate',
      });
    }
    if (this.props.permissions && this.props.permissions.canDeleteUser && !this.isVendorUser(user)) {
      menuOptions.push({
        type: 'delete',
        name: this.isVendorUser(user) ? `Remove as ${this.textMap.vendor}` : 'Delete',
        separated: this.props.permissions.canCreateUser && this.props.permissions.canCreateUser && !user.suspended ? true : false,
      });
    }
    if (this.props.permissions && this.props.permissions.canCreateUser && !user.suspended) {
      menuOptions.push({
        type: 'invite',
        name: 'Send Invite',
      });
    }
    let rect = event.target.getBoundingClientRect();
    return (
      <PopupMenu
        left={rect.left + 5}
        top={rect.top - 60}
        width={150}
        menuOptions={menuOptions} size="smaller"
        menuId="taskMenu"
        popupOnHover={false}
        handleMenuSelection={this.handleMenuSelection}
        height={85}
        handleClickAway={this.handleCloseMenu}
        doNotForgetTop={true}
      />
    );
  }

  isUserTeamLead(user){
    const { teams } = this.state;
    return teams.some(team => team.lead_user_id && team.lead_user_id == user.id);
  }

  changeTeamLead(user){
    this.setState({ displayPopup: 'change_team_lead' , editUser: Object.assign({}, user) });
  }

  handleCloseMenu() {
    this.setState({ menu: null, user: null });
  }

  handleMenuSelection(type) {
    const { user,users } = this.state;
    switch (type) {
    case 'delete':
      this.handleDeleteUser(user);
      break;
    case 'edit':
      this.handleUpdateUser(user);
      break;
    case 'suspend':
      this.handleSuspendUser(user,users);
      break;
    case 'unsuspend':
      this.handleUnsuspendUser(user);
      break;
    case 'invite':
      this.handleInviteUser(user);
      break;
    default:
      break;
    }
  }

  handleDeleteUser(user) {
    if(this.isUserTeamLead(user)){
      dataModel.showGlobalModal('SYSTEM_POPUP', {
        message: 'This user is a team Lead, and must be replaced as Lead on all teams before they can be deleted.',
        width: 300,
        height: 200,
        oneButton: true,
        okButtonText: 'OK',
        handleOwnerOk: () => {
          this.changeTeamLead(user);
        },
      });
    }
    else{
      const message = this.isVendorUser(user) ? this.textMap.vendorArchiveQuestion : this.textMap.userArchiveQuestion;
      dataModel.showGlobalModal('SYSTEM_POPUP', {
        message: message,
        width: 300,
        height: 200,
        cancelButtonText: this.textMap.cancel,
        okButtonText: this.isVendorUser(user) ? 'Remove' : this.textMap.deleteUser,
        handleOwnerOk: () => {
          this.doDeleteUser(user);
        },
      });
    }
  }

  doDeleteUser(user) {
    if (this.isVendorUser(user)) {
      dataModel.usersDAO.deleteVendorUser(user).then(vendorUser => {
      });
      this.setState({
        displayPopup: false,
      });
    }
    else {
      dataModel.usersDAO.deleteUser(user).then(() => {
        // Refresh data after deleting a user
        this.handleUserListRefresh();
      }); 
    }
  }

  handleUpdateUser(user) {
    let markets = user.markets && user.markets.length ? user.markets : null;
    this.savedEmail = user.email;

    this.setState({
      displayPopup: 'edit_user',
      originalUser: user,
      editUser: Object.assign({}, user),
      prevMarkets: markets,
    });
  }

  doDeactivateUser(user){
    const editedUser = Object.assign({}, user);
    editedUser.suspended = true;
    dataModel.usersDAO.updateUser(editedUser).then((response) => {
      dataModel.setDisableAppBackground(false);
      this.handleClosePopup();
      setTimeout(()=>{
        window.location.reload();
      }, 2000);
    });
  }

  handleSuspendUser(user,users) {
    if(user.active_projects_count === 0 && user.active_tasks_count === 0 && !this.isUserTeamLead(user)){
      const message = 'Are you sure you want to deactivate ' + user.name + '\'s user account ?';
      dataModel.showGlobalModal('SYSTEM_POPUP', {
        message: message,
        width: 300,
        height: 200,
        cancelButtonText: this.textMap.cancel,
        okButtonText: 'Deactivate',
        handleOwnerOk: () => {
          this.doDeactivateUser(user);
        },
      });
    }
    else{
      let markets = user.markets && user.markets.length ? user.markets : null;
      this.savedEmail = user.email;
      this.setState({
        displayPopup: 'deactivate_user',
        originalUser: user,
        editUser: Object.assign({}, user),
        prevMarkets: markets,
        users: users,
        copyUsers: users,
      });
    } 
  }

  handleUnsuspendUser(user) {
    let editedUser = Object.assign({}, user, { suspended: false, previous_suspended: true });
    this.handleToggleSuspendPopup(editedUser);
  }

  handleToggleSuspendPopup(editUser) {
    const popup = this.handleSetSuspendPopupContent(editUser);
    this.setState({ suspendPopup: popup });
  }

  handleSetSuspendPopupContent(editUser) {
    if (this.state.toggleActive) {
      this.setState({
        displayPopup: null,
      });
    }
    let message = null;
    let buttonText = null;
    if (!editUser.suspended) {
      message = 'Are you sure you wish to reactivate ' + editUser.name.trim() + '\'s user account? ' + editUser.name.trim() + ' will have access to Active Oversight.';
      buttonText = 'Activate User';
    } 
    dataModel.showGlobalModal('SYSTEM_POPUP', {
      message: message,
      width: 300,
      height: 184,
      cancelButtonText: this.textMap.cancel,
      okButtonText: buttonText,
      handleOwnerOk: () => {
        this.doActivateSuspendUser(editUser);
        if (this.state.toggleActive) {
          this.setState({
            displayPopup: null,
            toggleActive: false,
          });
        }
      },
      handleOwnerCancel: () => {
        if (this.state.toggleActive) {
          this.setState({
            displayPopup: 'edit_user',
            toggleActive: false,
          });
        }
      },
    });
  }

  doActivateSuspendUser(editUser) {
    dataModel.usersDAO.updateUser(editUser).then(user => {
      this.initializeData(this.props.currentCompany, this.props.permission, this.props.currentUser, 0);
      this.setState({
        editUser: user,
        toggleActive: false,
      });
    });
  }
  handleInviteUser(user) {
    dataModel.usersDAO.sendInvite(user);
  }

  isVendorUser(user) {
    return this.props.currentCompany && user && user.companies && user.companies[0] && user.companies[0].id != this.props.currentCompany.id;
  }

  handleCropPhoto(base64EncodedPhoto) {
    this.setState({
      file: base64EncodedPhoto,
    });
  }

  handleCancelCrop() {
    this.setState({
      displayPopup: this.state.currentAction,
      file: '',
      imagePreviewUrl: '',
    });
  }

  handleEndCrop() {
    this.setState({
      displayPopup: this.state.currentAction,
    });
  }

  handleDisplayPopup(type) {
    this.idCounter++;
    const users = this.state.usersListState;
    switch (type) {
    case 'add_user':
      const newUserWizardPage = [{
        caption: '',
        contents: <UserPopup
            id={'add-edit-user'}
            name=""
            email=""
            company={(this.props.permissions && this.props.permissions.isSuperUser) ? this.props.adminCompany : this.props.currentCompany}
            userRole=""
            external={false}
            file={this.state.file}
            profileImageUrl=""
            user={this.state.editUser}
            type="add_user"
            handleCropModal={this.handleCropModal}
            isDialog={true}
            imageRemoveButton={this.handleImageRemove}
            admin={this.props.permissions && this.props.permissions.isSuperUser}
            confirmPasswords={this.handlePasswordsMatch}
            handleToggleSuspendPopup={this.handleToggleSuspendPopup}
            handleToggleSuspension={this.handleToggleSuspension}
            isVendor={false} />,
      }];
      const newUserWizard = {
        popupId: 'newUser' + this.idCounter,
        captionPhoto: listViewIcon,
        width: 298,
        height: 460,
        okText: this.textMap.save.toUpperCase(),
        caption: this.textMap.addUser,
        pages: newUserWizardPage,
        handleValidation: this.handleUserFieldsValidation,
        handleOwnerDone: this.handleUserCreate,
        handleOwnerCancel: this.handleCancel,
      };
      return <WizardView key='new-user-wizard' wizard={newUserWizard} readyForUpdate={this.state.readyForUpdate} />;

    case 'manage_vendor_companies':
      return <AddAffiliateCompanyWizard companies={this.state.companies} handleWizardDone={this.handleWizardDone} addAsVendor={true} parentCompany={this.props.currentCompany} />;

    case 'manage_vendor_users':
      const vendorUserPage = [{
        caption: '',
        contents: <VendorUserSelection
            id={'add-edit-user'}
            name=""
            email=""
            currentCompany={this.props.currentCompany}
            external={false}
            type="user"
            isDialog={true}
            selectVendorUsers={this.handleSelectVendorUsers} />,
      }];
      const vendorUserWizard = {
        popupId: 'newVendorUser',
        width: 512,
        height: 342,
        okText: this.textMap.save.toUpperCase(),
        caption: `MANAGE ${this.textMap.vendor.toUpperCase()} USERS`,
        pages: vendorUserPage,
        handleOwnerDone: this.handleVendorUserOk,
        handleOwnerCancel: this.handleCancel,
      };
      return <WizardView key='vendor-user-wizard' wizard={vendorUserWizard} />;
    case 'edit_user':
      const updateUserWizardPages = [{
        caption: '',
        contents: <UserPopup
            id={'add-edit-user'}
            user={this.state.editUser}
            name=""
            email=""
            company={(this.props.permissions && this.props.permissions.isSuperUser) ? this.props.adminCompany : this.props.currentCompany}
            external={false}
            profileImageUrl=""
            file={this.state.file}
            handleCropModal={this.handleCropModal}
            type="edit_user"
            isDialog={true}
            updateUser={true}
            imageRemoveButton={this.handleImageRemove}
            confirmPasswords={this.handlePasswordsMatch}
            admin={this.props.permissions && this.props.permissions.isSuperUser}
            directories={this.state.directories}
            handleToggleSuspension={this.handleToggleSuspension}
            handleToggleSuspendPopup={this.handleToggleSuspendPopup}
            isVendor={this.isVendorUser(this.state.editUser)} />,
      }];
      const updateUserWizard = {
        popupId: 'updateUsr',
        captionPhoto: listViewIcon,
        width: 298,
        height: this.props.permissions && this.props.permissions.isSuperUser ? 460 : 420,
        okText: this.textMap.save.toUpperCase(),
        caption: this.state.editUser.first_name + ' ' + this.state.editUser.last_name,
        pages: updateUserWizardPages,
        handleValidation: this.handleUserFieldsValidation,
        handleOwnerDone: this.handleUserUpdate,
        handleOwnerCancel: this.handleCancel,
      };
      return <WizardView key='update-user-wizard' wizard={updateUserWizard} readyForUpdate={this.state.readyForUpdate} />;
    case 'cropper':
      const cropperPopupPages = [{
        caption: '',
        contents: <PhotoCropperPopup src={this.state.imagePreviewUrl} onUsePhoto={this.handleCropPhoto} marginTop={-82} />,
      }];

      const cropperWizard = {
        popupId: 'cropPhoto',
        width: 298,
        height: 272,
        hasOkButton: true,
        okText: this.textMap.usePhoto.toUpperCase(),
        caption: this.textMap.cropPhoto,
        pages: cropperPopupPages,
        handleOwnerDone: this.handleEndCrop,
        handleOwnerCancel: this.handleCancelCrop,
        oneButton: true,
      };
      return <WizardView key='photo-crop-wizard' wizard={cropperWizard} />;
      
    case 'deactivate_user':
      return <DeactivateUserPopup numberPerPage={PAGE_SIZE} currentCompany={this.props.currentCompany} users={users} currentUser={this.state.editUser} editUserDetails={this.state.editUser} handleClosePopup={this.handleClosePopup} isTeamLead={this.isUserTeamLead(this.state.editUser)}/>;
      
    case 'change_team_lead':
      return <ChangeTeamLeadPopup users={users} handleClosePopup={this.handleClosePopup} currentUser={this.state.editUser}/>;
      
    default :
      break;
    }
  }

  handleImageRemove(){
    const { displayPopup, editUser } = this.state;
    if(displayPopup === 'edit_user'){
      let updateEditUser = Object.assign({}, editUser);
      updateEditUser.profile_image = null;
      this.setState({ editUser: updateEditUser });
    }
    this.setState({
      file: '',
      imagePreviewUrl: '',
    });
  }
  
  checkIfUserAreChanged(editUser,originalUser){
    let isChanged = false;
    if(editUser && originalUser && editUser.first_name !== originalUser.first_name || editUser.last_name !== originalUser.last_name ||
       editUser.email !== originalUser.email || editUser.phone !== originalUser.phone ||
       editUser.role.id !== originalUser.role.id || editUser.title !== originalUser.title ||
       editUser.profile_image !== originalUser.profile_image){
      isChanged = true;
    }
    return isChanged;
  }

  handleCancel(popupId, animator) {
    const { editUser, originalUser } = this.state;
    if(editUser && originalUser && this.checkIfUserAreChanged(editUser,originalUser)){
      dataModel.showGlobalModal('SYSTEM_POPUP', {
        message: 'Are you sure you want to exit? Your changes will not be saved.',
        width: 300,
        height: 200,
        okButtonText: 'Yes',
        cancelButtonText: this.textMap.cancel, 
        handleOwnerOk: () => {
          if(animator){
            animator.processAnimationQueue();
          }
          this.setState({
            displayPopup: null,
            editUser: null,
            readyForUpdate: null,
            file: '',
            imagePreviewUrl: '',
          });
        },
      });
    }
    else{
      this.setState({
        displayPopup: null,
        editUser: null,
        readyForUpdate: null,
        file: '',
        imagePreviewUrl: '',
      });
    }
  }

  toggleDisabledUsersCheckBox(){
    const { isDisabledUsersIncluded } = this.state;
    this.setState({ isDisabledUsersIncluded: !isDisabledUsersIncluded }, ()=>{
      this.getUsersList(0);
    });
  }

  handleUserCreate() {
    this.handleUserUpdate(true);
  }

  findUniqueMarketIds(originalMkt, updatedMkt, marketBelongToLinkedProject) {
    if(updatedMkt.length > 0 && updatedMkt[0].market){
      const updatedMktIds = new Set(updatedMkt.map(market => market.market.id));
  
      const missingInUpdatedMktIds = originalMkt
        .filter(market => !updatedMktIds.has(market.id))
        .map(market => parseInt(market.id));
  
      const set1 = new Set(missingInUpdatedMktIds);
      const set2 = new Set(marketBelongToLinkedProject);
  
      const commonElements = [...set1].filter(item => set2.has(item));
  
      return commonElements;
    }
  }

  async handleUserUpdate(isNewUser) {
    const { originalUser, displayPopup } = this.state;
    // check to see if activated or not
    let addMarkets = [], delMarkets = [], uniqueMarketsIdsBelongToProjects = [], tempUpdatedUser = {};
    if (this.state.toggleActive) {
      this.handleSetSuspendPopupContent(this.state.editUser);
    }
    else {
      let updatedUser = null;
      const res = this.state.editUser.email == this.savedEmail ? { message: 'no check' } : await userService.checkEmailAvailability(this.state.editUser.email);
      if (res &&  res.message == 'email already exists') {
        let tempDisplayPopup = displayPopup;
        this.setState({
          displayPopup: null,
        });
        dataModel.showGlobalModal('SYSTEM_POPUP', {
          message: 'A user is already associated with this email: ' + this.state.editUser.email + '. User not updated.',
          okButtonText: 'OK',
          width: 320,
          height: 182,
          oneButton: true,
          handleOwnerOk: () => {
            this.setState({
              displayPopup: tempDisplayPopup,
            });
          },
        });
      }
      else {
        let passwordChange = false;
        updatedUser = Object.assign({}, this.state.editUser);
        if (this.state.file) {
          updatedUser.profile_image = this.state.file;
        }
        if (!isNewUser) {
          // we don't want this updating settings
          delete updatedUser.settings;
        }

        if (this.props.permissions && this.props.permissions.isSuperUser) {
          if (this.state.passwordsMatch) {
            passwordChange = true;
          }
        }
        if (updatedUser.phone) {
          let subString = updatedUser.phone.substring(0, 2);
          if (subString == '+1') {
            let withoutInt = updatedUser.phone.slice(2);
            updatedUser.phone = withoutInt;
          }
        }
        if (this.state.prevMarkets) {
          let originalMarkets = originalUser.markets;
          let updatedMarkets = updatedUser.markets;
          const marketBelongToLinkedProject = [];
          originalUser.active_projects.forEach(project=>{
            if(!marketBelongToLinkedProject.includes(project.market_id)){
              marketBelongToLinkedProject.push(project.market_id);
            }
          });
          uniqueMarketsIdsBelongToProjects = this.findUniqueMarketIds(originalMarkets, updatedMarkets, marketBelongToLinkedProject);
          this.state.prevMarkets.forEach(market => {
            let found = false;
            updatedMarkets.forEach(inMarket => {
              if (inMarket.market) {
                if (inMarket.market.id == market.id) {
                  found = true;
                }
              }
              else {
                if (inMarket.id == market.id) {
                  found = true;
                }
              }
            });
            if (!found) {
              if(!uniqueMarketsIdsBelongToProjects.includes(parseInt(market.id))){
                delMarkets.push(market);
              }
              else{
                updatedUser.markets.push(market);
              }
            }
          });
          updatedMarkets.forEach(market => {
            if (market.market) {
              if (market.market.toBeAdded) {
                addMarkets.push(market.market);
              }
            }
          });
        }
        else {
          updatedUser.markets.forEach(market => {
            if (market.market) {
              addMarkets.push(market.market);
            }
          });
        }
        tempUpdatedUser = Object.assign({}, updatedUser);
        const addOrEditUserPromise = isNewUser ? dataModel.usersDAO.createUser(updatedUser) : dataModel.usersDAO.updateUser(updatedUser);
        addOrEditUserPromise.then(user => {
          if (addMarkets.length) {
            dataModel.marketsDAO.addMarketUser(addMarkets, user.id);
          }
          if(uniqueMarketsIdsBelongToProjects.length){
            const uniqueCodes = [...new Set(originalUser.markets
              .filter(market => uniqueMarketsIdsBelongToProjects.includes(parseInt(market.id)))
              .map(market => market.code))];
            const codesString = uniqueCodes.join(', ');
            let message = `${delMarkets.length>1 ? codesString + ' markets are' : uniqueCodes + ' market is'} not removed because ${originalUser.name} have projects with same markets.`;
            dataModel.showGlobalModal('SYSTEM_POPUP', {
              message: message,
              okButtonText: 'OK',
              width: 300,
              height: 175,
              oneButton: true,
            });
          }
          if (delMarkets.length) {
            dataModel.marketsDAO.removeMarketUser(delMarkets, user.id);
          }
          if (isNewUser) {
            this.promptSendInvite(user);
            // Refresh user list after adding a user
            this.handleUserListRefresh();
          }
          else if (passwordChange) {
            dataModel.displayInfoErrorMessage('The password has been changed.', 4000, 1);
          }
        });
        this.setState(prevState => ({
          usersListState: prevState.usersListState.map(user => {
            if (user.id === this.state.editUser.id) {
              let tempMarketArray = [];
              const tempUser = { ...tempUpdatedUser };
              if (tempUser.phone) {
                let subString = tempUser.phone.substring(0, 2);
                if (subString !== '+1') {
                  let withInt = '+1' + tempUser.phone;
                  tempUser.phone = withInt;
                }
              }
              tempUser.markets.forEach(market=>{
                if(market.market){
                  tempMarketArray.push(market.market);
                }
                else if(market.type == 'market'){
                  tempMarketArray.push(market);
                }
              });
              if(tempMarketArray.length > 0){
                tempUser.markets = tempMarketArray;
              }
              return { ...user, ...tempUser };
            }
            return user;
          }),
        }));
        this.setState({
          displayPopup: null,
          editUser: null,
        });
      }
    }
  }

  handleUserFieldsValidation() {
    let message = null;
    if (!this.state.editUser.email || this.state.editUser.email == '') {
      message = 'Please add an ' + this.textMap.email;
    }
    else {
      if (!helper.validateEmail(this.state.editUser.email)) {
        message = 'Please add a valid ' + this.textMap.email;
      }
    }
    if (!message && (!this.state.editUser.last_name || this.state.editUser.last_name == '')) {
      message = 'Please add a ' + this.textMap.lastName;
    }
    if (!message && (!this.state.editUser.first_name || this.state.editUser.first_name == '')) {
      message = 'Please add a ' + this.textMap.firstName;
    }
    if (!message && !this.state.editUser.role) {
      message = 'Please select a ' + this.textMap.permission;
    }
    if (!message && (!this.state.editUser.markets || this.state.editUser.markets.length == 0)) {
      message = 'Please select a ' + this.textMap.market;
    }
    if (message) {
      dataModel.displayInfoErrorMessage(message, 4000, 2);
      return false;
    }
    return true;
  }

  promptSendInvite(user) {
    dataModel.showGlobalModal('SYSTEM_POPUP', {
      message: this.textMap.promptSendInvite,
      cancelButtonText: 'Later',
      okButtonText: 'Now',
      width: 300,
      height: 175,
      handleOwnerOk: () => {
        dataModel.usersDAO.sendInvite(user);
      },
    });
  }

  handleCropModal(file, type) {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      this.setState({
        file: file,
        imagePreviewUrl: reader.result,
        displayPopup: 'cropper',
        currentAction: type,
      });
    };
  }

  handlePasswordsMatch(match) {
    if (match == null) {
      this.setState({ passwordsMatch: false, readyForUpdate: match });
    } else {
      this.setState({ passwordsMatch: match, readyForUpdate: match });
    }
  }

  handleWizardDone() {
    this.setState({ displayPopup: null });
  }

  handleSelectVendorUsers(marketsToBeAdded, marketsToBeDeleted, usersToBeAdded, usersToBeDeleted) {
    this.setState({
      marketsToBeAdded: marketsToBeAdded,
      marketsToBeDeleted: marketsToBeDeleted,
      usersToBeAdded: usersToBeAdded,
      usersToBeDeleted: usersToBeDeleted,
    });
  }

  handleVendorUserOk(popupId) {
    this.handleVendorUserSave();
    this.setState({ displayPopup: null });
  }

  async handleVendorUserSave() {

    const { usersToBeAdded, marketsToBeAdded, usersToBeDeleted, marketsToBeDeleted } = this.state;
    if (usersToBeAdded && usersToBeAdded.length) {
      const responses = await dataModel.usersDAO.createVendorUsers(usersToBeAdded);
      this.setState({ usersToBeAdded: [] });
      for (let response of responses) {
        if (response.error) {
          dataModel.displayHTTPError('There was an error adding a market user.', response.error);
          return;
        }
      }
    }

    if (marketsToBeAdded && marketsToBeAdded.length) {
      const responses = await dataModel.marketsDAO.addMarketVendorUsersWithPromise(marketsToBeAdded);
      this.setState({ marketsToBeAdded: [] });
      for (let response of responses) {
        if (response.error) {
          dataModel.displayHTTPError('There was an error adding a market user.', response.error);
          return;
        }
      }
    }

    if (marketsToBeDeleted && marketsToBeDeleted.length) {
      const responses = await dataModel.marketsDAO.removeMarketVendorUsersWithPromise(marketsToBeDeleted);
      this.setState({ marketsToBeDeleted: [] });
      for (let response of responses) {
        if (response.error) {
          dataModel.displayHTTPError('There was an error removing a vendor user.', response.error);
          return;
        }
      }
    }

    if (usersToBeDeleted && usersToBeDeleted.length) {
      const responses = await dataModel.usersDAO.deleteVendorUsers(usersToBeDeleted);
      this.setState({ usersToBeDeleted: [] });
      for (let response of responses) {
        if (response.error) {
          dataModel.displayHTTPError('There was an error deleting a vendoruser.', response.error);
          return;
        }
      }
    }
  }

  handleFilterChange(filter, dontSearch) {
    const { searchString } = this.state;
    let companyIds = null;
    if (!filter && !searchString) {
      if (this.props.permissions && this.props.permissions.isSuperUser) {
        this.companiesDataSource = new CollectionDataSource('CompaniesCollection', 'Company', { companies: { vendor_companies: { additionalFields: ['is_vendor_company'] } } }, this.handleUpdateCompanies, 0, null, this.props.currentUser.id, null, 'directoryCompanies');
      }
      this.initializeData(this.props.currentCompany, this.props.permission, this.props.currentUser, 0);
      this.setState({ filter: null, companyIds },()=>{
        this.getUsersList();
      });
      return;

    }
    const users = this.state.usersListState;
    if(filter){
      if(!filter.hasOwnProperty('company')) filter.company = [];
      if(!filter.hasOwnProperty('market')) filter.market = [];
      if(!filter.hasOwnProperty('permission')) filter.permission = [];
     
      if (filter.permission==null) filter.permission = [];
      if(filter.market.length == 0 && filter.company.length == 0  && filter.permission.length == 0) {
        if (this.props.permissions && this.props.permissions.isSuperUser) {
          this.companiesDataSource = new CollectionDataSource('CompaniesCollection', 'Company', { companies: { vendor_companies: { additionalFields: ['is_vendor_company'] } } }, this.handleUpdateCompanies, 0, null, this.props.currentUser.id, null, 'directoryCompanies');
        }
        this.initializeData(this.props.currentCompany, this.props.permission, this.props.currentUser, 0);
        this.setState({ filter: null, companyIds }, ()=>{
          this.getUsersList();
        });
        return;
      }else {
        let filterOptions = {};
        
        Object.keys(filter).map(key => {
          if(filter[key] && filter[key].length){
            filterOptions[key] = filter[key];
          }
        });
        
        // var updatedData = users.filter(u => {
        //   let vendor_m=u.market_vendor_users?u.market_vendor_users:[];
        //   return (filterOptions.company ? filter.company.some(c => u.companies[0].id == c.id) : true) &&
        //   (filterOptions.market ? filter.market.some(m => u.markets.some(val=> val.id == m.id))  || filter.market.some(m => vendor_m.some(val=> val.market_id == m.id)) : true) && (filterOptions.permission ? filter.permission.some(r => u.role_id == r.id) : true)
        // })
        // this.props.setFilteredUsers(updatedData)
        if(filterOptions.company && filterOptions.company.length > 0){
          companyIds = filterOptions.company.map(c => c.id).join(',');
        }

        this.getUsersList(0, companyIds);
        this.setState({ filter, companyIds });
      }

      if(searchString && !filter) {
        const newUsers = users.filter((user) =>  {
          //if no input the return the original
          if (searchString == '') {
            return user;
          }
          //return the item which contains the user input
          else {
            return  user.first_name.toLowerCase().includes(searchString.toLowerCase()) || user.last_name.toLowerCase().includes(searchString.toLowerCase());
          }
        });
        this.props.setFilteredUsers(newUsers);
      }
      if(searchString) {
        const newUsers = users.filter((user) =>  {
          //if no input the return the original
          if (searchString == '') {
            return user;
          }
          //return the item which contains the user input
          else {
            return  user.first_name.toLowerCase().includes(searchString.toLowerCase()) || user.last_name.toLowerCase().includes(searchString.toLowerCase());
          }
        });
        this.props.setFilteredUsers(newUsers);

        this.setState({ filter });

      }
      this.setState({ filter });
    }
  }

  handleSearchChange(searchString) {
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }
    
    // Debounce the search to prevent multiple rapid calls
    this.searchTimer = setTimeout(() => {
      if (this.isInitializing) {
        return;
      }
      
      if (searchString && searchString.length > 2) {
        this.setState({ searchString }, () => {
          this.initializeData(this.props.currentCompany, this.props.permission, this.props.currentUser, 0);
        });
      } else if(!searchString) {
        if (this.props.permissions && this.props.permissions.isSuperUser) {
          this.companiesDataSource = new CollectionDataSource('CompaniesCollection', 'Company', { companies: { vendor_companies: { additionalFields: ['is_vendor_company'] } } }, this.handleUpdateCompanies, 0, null, this.props.currentUser.id, null, 'directoryCompanies');
        }
        this.setState({ searchString: '' }, () => {
          this.initializeData(this.props.currentCompany, this.props.permission, this.props.currentUser, 0);
        });
      }
    }, 300); // 300ms debounce
  }

  handleCreateDateRange(filter) {
    if (filter) {
      return {
        start_date: filter.startDate,
        end_date: filter.endDate,
      };
    }
    return {};
  }

  handleUserListRefresh() {
    this.initializeData(this.props.currentCompany, this.props.permission, this.props.currentUser, 0);
  }

  render() {

    const { displayPopup, menu } = this.state;
    const { permissions, currentUser, usersList, totalUsers } = this.props;
    const users = this.state.usersListState;
    let usersCount = '(0 of 0 results)';
    if (users && totalUsers) {
      usersCount = '(' + users.length + ' of ' + totalUsers + ' results)';
    }
    let popup = null;
    if (displayPopup) {
      popup = this.handleDisplayPopup(displayPopup);
    }

    const tableRows = this.createTableRows();
    let directorySearchFilter = <DirectorySearchFilter searchString={this.state.searchString} handleFilterChange={this.handleFilterChange} handleSearchChange={this.handleSearchChange} selectedFilters={this.state.filter} permissions={this.props.permissions} />;

    let footerRow = null;
    if(users && users.length < totalUsers && !this.state.loadingUsers){
      footerRow = <div className="scroll-footer">
        <div className="more-users-row footer-card" onClick={this.handleLoadMoreUsers}>
          Load More
        </div>
      </div>;
    }

    return (
      <div className='users'>
        {popup}
        <ReportHeader
          reportTitle={'Directory'}
          minWidth={200}
          hideExport={true}
        >
          <div className='users-header-item-count'>
            <div className='users-header-item-count-text'>{usersCount}</div>
          </div>
          {((permissions && permissions.isSuperUser) || (currentUser && currentUser.role.name == 'admin')) &&
            <div className='users-header-item' onClick={this.handlePopup} data-popup="add_user">
              <img src={addIcon} alt="Add New User" />
              <div className='users-header-item-text'>Add New User</div>
            </div>
          }
          {permissions && permissions.isSuperUser &&
            <div className='users-header-item' onClick={this.handlePopup} data-popup="manage_vendor_companies" >
              <img src={addIcon} alt="Manage Vendor Companies" />
              <div className='users-header-item-text'>Manage Vendor Companies</div>
            </div>
          }
          {((permissions && permissions.isSuperUser) || (currentUser && currentUser.role.name == 'admin')) &&
            <div className='users-header-item' onClick={this.handlePopup} data-popup="manage_vendor_users">
              <img src={addIcon} alt="Manage Vendor Users" />
              <div className='users-header-item-text'>Manage Vendor Users</div>
            </div>
          }
          <div className='users-header-disabled-user-checkbox'>
            <CheckBox checked={this.state.isDisabledUsersIncluded} toggleCheckBox={this.toggleDisabledUsersCheckBox}/>
            Include Inactive Users
          </div>
          <div className="directory-search">
            {directorySearchFilter}
          </div>

        </ReportHeader>

        <div className='users-table'>
          {this.createTableHeader()}
          <div className={'users-table__scroller infinite-scrolling'}>
            <div className='users-table__rows' ref={(element) => { this.list = element; }}>

              {tableRows}
              {footerRow}
              {menu}
            </div>
          </div>
          {
            this.state.loadingUsers && <div className='users-loading-more-indicator'><LoadingDots accent={this.accent} /></div>
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    permissions: state.new_users ? state.new_users.permissions : null,
    currentUser: state.new_users.currentUser,
    currentCompany: state.new_companies.currentCompany,
    currentUsers: state.new_users,
    pageNumber: state.userState.pageNumber,
    usersList: state.userState.usersList,
    totalUsers: state.userState.totalUsers,
    filteredUsers: state.userState.filteredUsers,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUsersList: (response) => dispatch(setUsersList(response)),
    setFilteredUsers: (response) => dispatch(setFilteredUsers(response)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Users);



// WEBPACK FOOTER //
// ./src/containers/Directory/Users/index.js